<template>
  <div id="landing"></div>
</template>

<script>
import common from '@/utils/common'

export default {
  name: 'Landing',
  mixins: [common],
  created() {
    const userCode = this.$route.params.userCode
    if (!this.isEmpty(userCode)) {
      this.$store.commit('setLandingCode', userCode)

      const user = this.$store.state.auth.user
      if (!this.isEmpty(user)) {
        this.$store
          .dispatch('auth/checkAccessToken')
          .then(data => {
            if (data && data.active) {
              this.goReplace('connections')
            } else {
              this.$store.dispatch('auth/logout')
              this.goReplace('')
            }
          })
          .catch(() => {
            this.$store.dispatch('auth/logout')
            this.goReplace('')
          })
      } else {
        this.goReplace('')
      }
    }
  }
}
</script>

<style></style>
